import { showApiErrors } from '@/utils';
import { createSlice, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';
import { getGeneralSettings, updateGeneralSettings } from './actionCreators';
import { initialState, SETTINGS_SLICE_NAME, SettingsState } from './models';

export const slice = createSlice({
  name: SETTINGS_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addMatcher(isFulfilled(getGeneralSettings, updateGeneralSettings), (state: SettingsState, action) => {
        const { payload } = action;
        state.isLoading = false;
        state.error = null;
        state.generalSettings = payload;
      })
      .addMatcher(isPending(updateGeneralSettings, getGeneralSettings), (state: SettingsState) => {
        state.isLoading = true;
        state.error = null;
      })
      .addMatcher(isRejected(updateGeneralSettings, getGeneralSettings), (state: SettingsState, action) => {
        const { error } = action;
        state.isLoading = false;
        state.error = error;

        showApiErrors(error);
      });
  },
});

export default slice.reducer;
